<template>
    <div class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card"
             @click.stop="">
            <header class="modal-card-head">
                <slot name="header">
                </slot>
                <button v-if="showClose" class="delete"
                        @click="close"></button>
            </header>
            <section class="modal-card-body">
                <slot name="body">
                </slot>
            </section>
            <footer v-if="showFooter" :class="footerClass">
                <slot name="footer"></slot>
            </footer>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      showClose: {
        default: true
      },
      footerClass: {
        type: String,
        default: 'modal-card-foot'
      },
      showFooter: {
        type: Boolean,
        default: true
      }
    },
    created () {
      this.escapeHandler = e => {
        if (e.key === 'Escape') {
          this.close();
        }
      };
      document.body.style.setProperty('overflow', 'hidden');
      document.body.style.setProperty('height', '100vh');
      document.addEventListener('keydown', this.escapeHandler);
    },
    destroyed () {
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('height');
      document.removeEventListener('keydown', this.escapeHandler);
    },
    methods: {
      close () {
        this.$emit('close');
      }
    }
  };
</script>
